import React, { useMemo, useState, useRef } from 'react'
import { PLATFORM_VALUE } from 'meinian-package/src/component/platformConfig'
// import useIntersectionObserver from 'meinian-package/src/common/hooks/useIntersectionObserver'
import Select from 'meinian-package/src/baseComponent/select'
import * as userAuth from 'meinian-package/src/utils/auth'
import { IMAGE_DETAIL_TAB } from '..'
import { SwitchPageTab } from '../../../../components/switchTab'
import List from './list'
import styles from './index.module.less'

const Ranks = {
  [PLATFORM_VALUE.ITEM]: [
    { label: '综合排序', value: '0,0' },
    { label: '销量最多', value: '11,0' },
    { label: '月销量最多', value: '9,0' },
    { label: '收藏最多', value: '10,0' },
    { label: '最新上架', value: '1,0' },
    { label: '价格最低', value: '13,1' },
    { label: '价格最高', value: '13,0' },
  ],
  [PLATFORM_VALUE.DY]: [
    { label: '综合排序', value: '0,0' },
    { label: '月销量最多', value: '9,0' },
    { label: '最新上架', value: '14,0' },
    { label: '价格最低', value: '13,1' },
    { label: '价格最高', value: '13,0' },
  ],
  [PLATFORM_VALUE.INS]: [
    { label: '综合排序', value: '0,0' },
    { label: '点赞最多', value: '2,0' },
    { label: '评价最多', value: '3,0' },
    { label: '最新发布', value: '1,0' },
  ]
}

export default ({ tabValue, imgInfoList }) => {
  const transformStyle = useMemo(() => {
    if (tabValue === IMAGE_DETAIL_TAB.RECOMMEND) {
      return {
        top: '0'
      }
    }
    return {
      top: '-100vh'
    }
  }, [tabValue])
  const $screen = useRef(null)

  const [rankStatus, setRankStatus] = useState('0,0')
  const [platformId, setPlatformId] = useState(userAuth.hasAuth('item_collect_or_cancel') ? PLATFORM_VALUE.ITEM
    : userAuth.hasAuth('dl_ins') ? PLATFORM_VALUE.INS
      : PLATFORM_VALUE.DY)

  const _options = useMemo(() => {
    return [
      { label: '淘系商品', value: PLATFORM_VALUE.ITEM, auth: userAuth.hasAuth('item_collect_or_cancel') && (userAuth.hasAuth('dl_tiktok_data') || userAuth.hasAuth('dl_ins')) },
      { label: '抖衣商品', value: PLATFORM_VALUE.DY, auth: userAuth.hasAuth('dl_tiktok_data') && (userAuth.hasAuth('item_collect_or_cancel') || userAuth.hasAuth('dl_ins')) },
      { label: 'INS图片', value: PLATFORM_VALUE.INS, auth: userAuth.hasAuth('dl_ins') && (userAuth.hasAuth('dl_tiktok_data') || userAuth.hasAuth('item_collect_or_cancel')) }
    ].filter(i => i.auth)
  }, [])

  return <div className={styles.recommend} style={{ ...transformStyle }}>
    <SwitchPageTab
      value={platformId}
      options={_options}
      onChange={(val) => {
        setPlatformId(val)
        setRankStatus('0,0')
      }}
      style={{ paddingLeft: '104px', paddingRight: '96px' }}
      renderRight={() => <Select
        displayTextClassName="fill-grey-bg"
        placement="bottomRight"
        value={rankStatus}
        displayStyle={{ maxWidth: 'unset' }}
        placeholder="今日"
        allowClear={false}
        onChange={(_rankStatus) => {
          setRankStatus(_rankStatus)
        }}
        data={Ranks[platformId]}
      />}
    />
    <div className={styles.recommendContent} ref={$screen}>
      <List imgInfoList={imgInfoList} rankStatus={rankStatus} platformId={platformId} />
    </div>
  </div>
}
